import script from "./KeySelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeySelector.vue?vue&type=script&setup=true&lang=ts"

import "./KeySelector.vue?vue&type=style&index=0&id=923477c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923477c6"]])

export default __exports__